<script setup lang="ts">
import { defineProps } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  isActive: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <v-expansion-panel>
    <v-expansion-panel-title :class="isActive ? 'font-weight-bold' : 'font-weight-regular'">
      {{ props.title }}
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <slot></slot>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<style scoped></style>
